const Hosts = {
    reseller: "themediacdn.com",
    streamhoster: "streamhoster.com"
};

const ServiceHosts = {
    content: {
        reseller: `c.${Hosts.reseller}`,
        streamhoster: `c.${Hosts.streamhoster}`,
    },
    hosts: Hosts
};

class Hostname {

    static isResellerHostname(): boolean {
        return window.location.hostname.toLowerCase().indexOf(Hosts.reseller) > -1;
    }

}



export {ServiceHosts, Hostname}